import { ChatMessageTargetType, ChatMessageType } from '../../enums';
import { IsEnum, IsOptional, IsString, IsUUID, ValidateIf } from 'class-validator';

export class CreateChatMessageDto {
	@IsEnum(ChatMessageTargetType)
	target_type: ChatMessageTargetType;

	@IsUUID()
	target_id: string;

	@IsEnum(ChatMessageType)
	type: ChatMessageType;

	@ValidateIf((o) => o.type === ChatMessageType.TextImage)
	@IsOptional()
	@IsString()
	text?: string;

	@ValidateIf(
		(o) => o.type === ChatMessageType.TextImage && o.target_type === ChatMessageTargetType.Broadcast
	)
	@IsOptional()
	@IsString()
	image_id?: string;

	@ValidateIf(
		(o) => o.type === ChatMessageType.Gif && o.target_type === ChatMessageTargetType.Lobby
	)
	@IsOptional()
	@IsString()
	gif?: string;

	@ValidateIf(
		(o) => o.type === ChatMessageType.Sticker && o.target_type === ChatMessageTargetType.Lobby
	)
	@IsOptional()
	@IsString()
	sticker?: string;
}
